import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightBulb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLightBulb"><Path d="M19.9998 9.00089C19.9998 11.249 19.072 13.2807 17.5803 14.7334H6.41753C4.9259 13.2807 3.99805 11.249 3.99805 9.00089C3.99805 4.58212 7.58016 1 11.9989 1C16.4177 1 19.9998 4.58212 19.9998 9.00089Z" fill="currentColor"/><Path d="M7.99775 19V16.2334H16.0001V19H7.99775Z" fill="currentColor"/><Path d="M16 20.5H8V22H16V20.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightBulb;
